export enum ELanguages {
	EN = 'en',
}
